// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * Update [[LightsController]] in OccViewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    let aController = theModule.lights;
    aController.getLights = function () {
        //@ts-ignore
        const aLights = this._cppGetLights();
        const aRet = [];
        for (let i = 0; i < aLights.size(); i++) {
            aRet.push(aLights.get(i));
        }
        return aRet;
    };
});
